module.exports = ".file-list-container {\r\n    max-height: 100px;\r\n    overflow-x: hidden;\r\n    overflow-y: scroll;\r\n}\r\n\r\n.file-list-container tr {\r\n    border: 1px solid lightgrey;\r\n}\r\n\r\n.file-list-container td {\r\n    padding: 6px;\r\n}\r\n\r\n.file-list-container .fa-times {\r\n    margin-left:5px;\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/angular_library/components/mail-composer/angular-mail-composer.css
// module id = ./src/angular_library/components/mail-composer/angular-mail-composer.css
// module chunks = main